import graphql__f0513e4afa2e53eb7af2 from "./__generated__/AnswerPreviewBudget_answer.graphql.js";import { createFragmentContainer, graphql } from "react-relay";
import classNames from "classnames";

import Collapse from "../Utils/Collapse";
import CollapseSwitch from "../Utils/CollapseSwitch";
import CollapseContent from "../Utils/CollapseContent";
import BudgetAmount from "../Form/Field/Budget/BudgetAmount";

const AnswerPreviewBudget = props => {
  const { answer } = props;
  const { balance, answers } = answer;
  const { unit } = answer.formField;

  const balanceClassName = classNames("budget-preview-balance", "margin-bottom-sm", {
    "text-danger": balance < 0,
    "text-success": balance >= 0
  });

  return (
    <div className="answer-preview-budget w-100">
      <div className={balanceClassName}>
        <strong>Total: </strong>
        <BudgetAmount amount={balance} unit={unit} />
      </div>

      {answers && answers.length > 0 && (
        <div className="budget-preview-chapters">
          {answers.map(chapter => {
            const { id, formField, balance: chapterBalance, budgetLines } = chapter;

            // Only show chapters with selected budget lines
            if (!budgetLines || budgetLines.length === 0) return null;

            const chapterContent = (
              <div className="budget-chapter-lines">
                <ul className="list-unstyled margin-bottom-none">
                  {budgetLines.map(budgetLine => {
                    const { option, value, stepLabel } = budgetLine;

                    return (
                      <li key={option.id} className="budget-line-item">
                        <div className="d-flex justify-content-between">
                          <span>
                            {option.name}

                            {stepLabel && (
                              <span className="text-muted"> ({stepLabel})</span>
                            )}
                          </span>

                          <BudgetAmount
                            amount={value}
                            unit={unit}
                            className="margin-left-md text-right nowrap"
                          />
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );

            const switchClassName = classNames(
              "btn",
              "btn-unstyled",
              "btn-block",
              "padding-sm",
              "border-bottom",
              "margin-bottom-none"
            );

            return (
              <Collapse key={id} expanded={false}>
                <div className="border rounded margin-bottom-sm">
                  <CollapseSwitch
                    className={switchClassName}
                    labelClassName="d-flex justify-content-between align-items-center"
                    headingLevel={4}
                  >
                    <span className="text-legend text-small">{formField.label}</span>

                    <BudgetAmount
                      amount={chapterBalance}
                      unit={unit}
                      className="margin-x-sm"
                    />
                  </CollapseSwitch>

                  <CollapseContent>
                    <div className="padding-sm text-small">{chapterContent}</div>
                  </CollapseContent>
                </div>
              </Collapse>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default createFragmentContainer(AnswerPreviewBudget, {
  answer: graphql__f0513e4afa2e53eb7af2
});
